import {
  Input,
} from '@cloudscape-design/components';
import React, {
  useCallback,
  useState,
} from 'react';
import { useNavigate } from 'react-router-dom';

import { useNotifications } from '../../features/notifications';
import { fetchUserByEmail } from '../../utils/queries';

function OmniSearch() {
  const [input, setInput] = useState('');
  const [isSearching, setIsSearching] = useState(false);
  const navigate = useNavigate();
  const { addNotification, removeNotification } = useNotifications();
  const errorId = 'omni-search-error';

  const getUserByEmail = useCallback(async (userEmail) => {
    try {
      setIsSearching(true);
      removeNotification(errorId);
      const user = await fetchUserByEmail(userEmail);
      if (user.id) {
        setInput('');
        navigate(`/user/${user.id}`);
      }
    } catch (err) {
      addNotification({
        type: 'error',
        dismissible: true,
        content: err.message,
        id: errorId,
      });
    }
    setIsSearching(false);
  }, [addNotification, navigate, removeNotification]);

  return (
    <Input
      placeholder="Search for a user by email address"
      value={input}
      onChange={({ detail }) => { setInput(detail.value); }}
      onKeyDown={({ detail }) => {
        if (detail.key === 'Enter') {
          const trimmedInput = input.trim();
          if (trimmedInput) {
            getUserByEmail(trimmedInput);
          }
        }
      }}
      disabled={isSearching}
    />
  );
}

export default OmniSearch;
